import { Select,Form, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { useFinanceSubTypeListQuery,} from '../store/ReactWebSiteApi';
import { useNavigate } from 'react-router-dom';

function FormItemBalanceTypeAdd(props) {
    const navi = useNavigate()
    const mainTypeOptions = [       
        {
            value:"3",
            label:'费用支出',
        },
        {
            value:"4",
            label:'其他收入',
        },
        {
            value:"5",
            label:'其他支出',
        },        
    ]
    const [mainType,setMainType] = useState();
    const [list,setList] = useState();
    const {data, isSuccess} = useFinanceSubTypeListQuery({
        efst_e_id:localStorage.getItem('e_id'),
        efst_finance_type_id:mainType,
        ect_name:props.ect_name,
        ect_mode:props.ect_mode,
        efst_state:'2'
    });
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {efst_id,efst_name,}=item;
                    return item = {value:efst_id,label:efst_name}
                })
                setList(newArr)
            }else{
                setList([])
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label='科目'
                wrapperCol={props.wrapperCol} 
                required={props.required}          
                style={{marginBottom:"0"}}   
                labelCol={props.labelCol}               
            >
                <Space>
                    <Form.Item name={props.mainName}>
                        <Select 
                            options={mainTypeOptions} 
                            onChange={(e,f) => {
                                setMainType(e)
                                props.getMainType(e)
                            }}
                            defaultValue={props.defaultId}
                            placeholder={props.defaultId}
                            style={{width:'100px'}}
                        />
                    </Form.Item>
                    <Form.Item name={props.subName} label='类型'>
                        <Select 
                            options={list} 
                            onChange={(e,f) => {
                                console.log(e,f);
                                props.getSubType(f.value,f.label)
                            }}
                            defaultValue={props.defaultId}
                            placeholder={props.defaultId}
                            style={{width:'200px'}}
                        />
                    </Form.Item>
                    {props.setType && <Form.Item>
                        <a onClick={() => {
                            navi('/BalanceType')
                        }}>设置</a>
                    </Form.Item>}
                </Space>
            </Form.Item>
        </>
    )
}

export default FormItemBalanceTypeAdd